var ProductComplianceTechnicalHeadingTypeEnum;
(function (ProductComplianceTechnicalHeadingTypeEnum) {
    ProductComplianceTechnicalHeadingTypeEnum["energyEfficiencyClass"] = "ENERGY_EFFICIENCY_CLASS";
    ProductComplianceTechnicalHeadingTypeEnum["rescaled"] = "PRODUCT_INFO_SHEET";
    ProductComplianceTechnicalHeadingTypeEnum["nonRescaled"] = "PRODUCT_FICHE";
    ProductComplianceTechnicalHeadingTypeEnum["hyperlink"] = "HYPERLINK";
    ProductComplianceTechnicalHeadingTypeEnum["unifiedWaterLabel"] = "GRAPHICAL_ELEMENT";
    ProductComplianceTechnicalHeadingTypeEnum["repairabilityIndex"] = "REPAIRABILITY_INDEX";
    ProductComplianceTechnicalHeadingTypeEnum["durabilityIndex"] = "DURABILITY_INDEX";
    ProductComplianceTechnicalHeadingTypeEnum["doNotDiy"] = "INSTALLATION_TYPE";
    ProductComplianceTechnicalHeadingTypeEnum["disclaimer"] = "DISCLAIMER";
})(ProductComplianceTechnicalHeadingTypeEnum || (ProductComplianceTechnicalHeadingTypeEnum = {}));
export default ProductComplianceTechnicalHeadingTypeEnum;
//# sourceMappingURL=ProductComplianceTechnicalHeadingTypeEnum.js.map